import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

/**
 * Full-page fallback rendered by the Sentry.ErrorBoundary when an uncaught
 * React error propagates to the root.  Styled to match the CMS visual language
 * (slate-900 sidebar, slate-50 background, blue accent).
 */
export default function SentryErrorFallback() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-500" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-slate-900">
            Something went wrong
          </h1>
          <p className="text-sm text-slate-500 leading-relaxed">
            An unexpected error occurred. The issue has been reported automatically.
            You can try reloading the page — if the problem persists, contact support.
          </p>
        </div>

        {/* Branding */}
        <div className="pt-2">
          <span className="text-sm font-semibold">
            <span className="text-blue-500">Douro</span>
            <span className="text-slate-400"> Make</span>
          </span>
        </div>

        {/* Action */}
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
        >
          <ArrowPathIcon className="h-4 w-4" />
          Reload page
        </button>
      </div>
    </div>
  );
}
